import axios from 'axios';
import { API_BASE_URL } from '../data/apiURLs';

interface LogEvent {
  event: string;
  payload: string;
  client_timestamp: string;
  url: string;
  username: string;
  condition: string;
}

export const logEvent = async (event: string, payload: string, url: string) => {
  try {
    const username = localStorage.getItem('username') || 'anonymous';
    
    const logData: LogEvent = {
      event,
      payload,
      client_timestamp: new Date().toISOString(),
      url,
      username,
      condition: 'system'
    };

    await axios.post(`${API_BASE_URL}/logs/`, logData);
  } catch (error) {
    console.error('Error logging event:', error);
  }
};